import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yarn-complexity',
  templateUrl: './yarn-complexity.component.html',
  styleUrls: ['./yarn-complexity.component.css']
})
export class YarnComplexityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
